import { useState, useEffect, useMemo } from 'react';
import { defaultRegistry } from './defaultRegistry';
export function useResolvedProvider(appId, providerKey, registry = defaultRegistry) {
  const providerType = useMemo(() => registry.getProviderType(appId, providerKey), [appId, providerKey, registry]);
  const syncComponents = useMemo(() => {
    var _registry$getComponen;
    if (providerType !== 'sync') return null;
    return (_registry$getComponen = registry.getComponentsSync(appId, providerKey)) !== null && _registry$getComponen !== void 0 ? _registry$getComponen : null;
  }, [providerType, appId, providerKey, registry]);
  const [components, setComponents] = useState(syncComponents);
  const [isLoading, setIsLoading] = useState(providerType === 'async');
  useEffect(() => {
    if (providerType === 'sync') {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setComponents(syncComponents);
      setIsLoading(false);
      return;
    }
    if (providerType === 'none') {
      setComponents(null);
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    setComponents(null);
    registry.resolveComponents(appId, providerKey).then(resolved => {
      if (!cancelled) {
        setComponents(resolved !== null && resolved !== void 0 ? resolved : null);
        setIsLoading(false);
      }
    }).catch(() => {
      if (!cancelled) {
        setIsLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [providerType, syncComponents, appId, providerKey, registry]);
  return {
    components,
    isLoading
  };
}